/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, {useEffect, useMemo, useState} from 'react';
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Grid,
  Link,
  Paper,
  Toolbar,
  Typography,
} from '@mui/material';
import {useLocation, useParams} from 'react-router-dom';

// @components
import CreateEmployee from '../Employer/components/CreateEmployee/CreateEmployee';

// @assets
import {MultiQuestStyles} from "../../assets/css/questionnaire-style";
import defaultLogo from '../../assets/images/logoDashboardPublic.svg';

// @constants
import { ROUTENAME } from '../../navigation/RouteName';

// @store
import { useUI } from '../../app/context/ui';

// @helpers
import AppHelper from '../../helpers/AppHelper';

// @services
import EmployeeCompanyServiceNewApi from '../../services/newApi/EmployeeCompanyServiceNewApi';
import { HeaderStyles } from '../../assets/css/general-style';

const ExternalEmployer = () => {
  const location = useLocation();
  const {hashToken} = useParams()
  let token = location.search.split('=')[1] ?? '';
  const styles = useMemo(() => MultiQuestStyles(), []);
  const styleHeder = useMemo(() => HeaderStyles(), []);
  const { blockUI, snackbarUI } = useUI();
  const employeeService = useMemo(() => new EmployeeCompanyServiceNewApi(), []);
  const [isRyzeOrganization, setIsRyzeOrganization] = useState(false);
  const [logo, setLogo] = useState(null);

  if (!token) {
    return null;
  } else {
    token = decodeURIComponent(token);
  }
   
  const getHostCompany = async () => {
    try {
      employeeService.setAccessToken(token)
      blockUI.current.open(true);
      const response = await employeeService.getCompanyApiHost(hashToken, token);
      setIsRyzeOrganization(response?.data?.customWorkflow);
      setLogo(response?.data?.logo ?? defaultLogo);
      blockUI.current.open(false);
    } catch (error) {
      blockUI.current.open(false);
      AppHelper.checkError(error, snackbarUI);
    }
  }
    
  useEffect(() => {
    if(token)getHostCompany();
  }, [token])
  
  return (
    <>
      {!isRyzeOrganization
        ? <Box>
            <>
              <CssBaseline />
              <AppBar position='fixed' sx={styleHeder.appBar}>
                <Toolbar sx={{...styleHeder.toolbar, paddingTop: '30px'}}>
                  <Grid sx={styleHeder.containerImg}>
                    <Box sx={styleHeder.companyLogo}>
                      <Link to={{pathname: ROUTENAME.dashboard}}>
                      {logo && <img src={logo} alt='logo' className="imageHeader"/>}
                      </Link>
                    </Box>
                  </Grid>
                
                </Toolbar>
              </AppBar>
            </>
            <Container>
              <Paper elevation={4} sx={styles.paper}>
                <CreateEmployee
                  token={token}
                  isRyze={isRyzeOrganization}
                />
              </Paper>
            </Container>
          </Box>
        : <Container>
            <Paper elevation={4} sx={styles.paper}>
              <Typography
                sx={{
                  fontSize: '20px'
                }}
              >This link is no longer valid</Typography>
            </Paper>
          </Container>
      }
    </>
  );
};

export default ExternalEmployer;
